import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { AuthCredentials } from "../types/Auth/Auth";
import { ArrayStorageRepository } from "./abstract/array.storage.repository";

@Injectable({
  providedIn: "root",
})
export class UsersRepository extends ArrayStorageRepository<AuthCredentials> {
  constructor(storage: Storage) {
    super(storage, "users", "userID");
  }

  public saveUser(user: AuthCredentials): Promise<AuthCredentials> {
    return super.saveRecord(["email", "password"], user);
  }

  public getUserByEmail(email: string, env: string): Promise<AuthCredentials> {
    return super.getByValues(["email", "env"], [email, env]);
  }
}
